<div
  class="chip"
  [class.invalid]="chip.invalid || false"
  [class.disabled]="chip.disabled || false"
  [rivTooltip]="tooltipTemplate"
  [rivTooltipCloseDelay]="1250"
  [rivTooltipPreferredPosition]="'top-center'"
>
  <span class="text">{{ chip.text }}</span>
  <span class="subtext" *ngIf="!!chip.subtext">{{ chip.subtext }}</span>
  <riv-icon
    *ngIf="chip.invalid"
    [name]="'AlertCircle'"
    size="16"
    class="icon"
    (click)="fixInvalidAction()"
  ></riv-icon>
  <riv-icon
    *ngIf="!chip.disabled"
    [name]="'X'"
    size="16"
    class="icon"
    (click)="remove.emit()"
  ></riv-icon>
</div>

<ng-template #tooltipTemplate>
  <ng-container
    *ngIf="!chip.editPatient && !chip.selectContactField; else invalidTooltip"
  >
    <p>
      {{ chip.description }}
    </p>
    <p>
      <a class="link" rivetLink (click)="openPatientEdit.emit()">
        <u>Edit patient</u></a
      >
    </p>
  </ng-container>
  <ng-template #invalidTooltip>
    <ng-container *ngIf="chip.editPatient">
      <p>
        {{
          chipType == BulkEstimateContactType.SMS
            ? 'Invalid or missing mobile.'
            : 'Invalid or missing email.'
        }}
      </p>
      <p>
        <a class="link" rivetLink (click)="openPatientEdit.emit()">
          <u>Edit patient</u></a
        >
      </p>
    </ng-container>
    <ng-container *ngIf="!chip.editPatient && chip.selectContactField">
      <p>
        This patient has multiple
        {{
          chipType == BulkEstimateContactType.SMS
            ? 'mobile numbers. Select one or more numbers '
            : 'emails. Select one or more emails '
        }}
        for this patient to continue.
      </p>
      <p>
        <a class="link" rivetLink (click)="openSelectContactField.emit()">
          <u>
            {{
              chipType == BulkEstimateContactType.SMS
                ? 'Select mobile'
                : 'Select email'
            }}
          </u>
        </a>
      </p>
    </ng-container>
  </ng-template>
</ng-template>
